<template>
  <div class="root-box">
    <div>
      <div class="route-detail">
        <el-table :key="tableKey" :data="list" :default-expand-all="false" max-height="650" :show-header="false"
          :row-class-name="tableRowClassName" class="no-hover" ref="table" stripe>
          <el-table-column type="expand" show-overflow-tooltip>
            <template slot-scope="props">
              <div class="table-expand">
                <el-table :data="props.row.orderList" :show-header="false" class="no-hover"
                  @row-dblclick="showOnwayDetect">
                  <el-table-column prop="orderIndex" width="50" label="订单序号">
                    <template slot-scope="scope">
                      <span class="order-index">{{ scope.row.orderIndex + 1 }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="showTime" width="120" label="时间"></el-table-column>
                  <el-table-column prop="orderSource" width="80" label="渠道">
                    <template slot-scope="scope">
                      <div v-order-source="scope.row.orderSource"></div>
                      <vip-label :vip="scope.row.vip" />
                    </template>
                  </el-table-column>

                  <el-table-column prop="number" width="60" label="订票">
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row | orderTypeTransfer }}
                      </div>
                      <div v-if="scope.row.togetherPwd" class="together">
                        {{ scope.row.togetherPwd }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" width="100" label="总价">
                    <template slot-scope="scope">
                      <span v-operate-order:bill="scope.row.id">{{ scope.row.price | moneyFormat }}元</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="telephone" label="手机" width="130">
                    <template slot-scope="scope">
                      <tel-cell :order="scope.row" />
                    </template>
                  </el-table-column>

                  <el-table-column prop="departure" label="起点">
                    <template slot-scope="scope">
                      <span class="pointer" @click="showPassengetMap(props.row.route, props.row.orderList, true)">{{
                        scope.row.departure }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="destination" label="终点">
                    <template slot-scope="scope">
                      <span class="pointer" @click="showPassengetMap(props.row.route, props.row.orderList, false)">{{
                        scope.row.destination }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="seatDesc" width="80" label="座位"></el-table-column>
                  <el-table-column prop="psgMessage" width="130" label="乘客留言">
                    <template slot-scope="scope">
                      <limit-text :width="130" :text="scope.row.psgMessage"></limit-text>

                      <limit-text :width="150" :text="scope.row.baggageRemark | baggagesRemarkFilter"></limit-text>

                      <el-button v-if="scope.row.baggageAudit === 2" type="text" size="small"
                        @click="aduitBag(scope.row, true)">查看行李</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="司机备注">
                    <template slot-scope="scope">
                      <limit-text :width="130" :text="scope.row.remark"></limit-text>
                    </template>
                  </el-table-column>
                  <el-table-column prop="adminMessage" label="客服备注">
                    <template slot-scope="scope">
                      <limit-text :width="130" :text="scope.row.adminMessage"></limit-text>
                      <span v-if="scope.row.sysTipMessage">{{ scope.row.sysTipMessage }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="realTimePositioning">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.realTimePositioning" type="text" size="small"
                        @click="showRealTimePosition(scope.row)">实时位置</el-button>
                    </template>
                  </el-table-column>

                  <el-table-column prop="orderStatus" width="110" label="订单状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.abnormalFinish">超时未上车</span>
                      <span v-else>{{
                        scope.row.routeStatus | enumTransfer(routeDetailOpts)
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="payStatus" width="80" label="支付状态">
                    <template slot-scope="scope">
                      <span :class="{ red: scope.row.payStatus === 0 }">{{
                        scope.row.payStatus | enumTransfer(payStatusOpts)
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column width="100" prop="createTime" label="下单时间"></el-table-column>

                  <el-table-column prop="id" label="操作" align="right" fixed="right" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="openMsgModal(scope.row)">留言</el-button>
                      <el-dropdown @command="(command) => handleCommand(command, scope.row, props.row.route)">
                        <span class="el-dropdown-link">
                          其他
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <!-- <el-dropdown-item :disabled="scope.row.orderStatus === 'FINISH'"
                            command="1">取消</el-dropdown-item> -->
                          <el-dropdown-item v-if="scope.row.orderType !== 4" command="2">改签/退票</el-dropdown-item>
                          <el-dropdown-item :disabled="scope.row.orderStatus === 'FINISH'"
                            command="3">撤回</el-dropdown-item>
                          <el-dropdown-item v-if="scope.row.orderType !== 4" command="10">乘客违约关单</el-dropdown-item>
                          <el-dropdown-item>
                            <span v-goRouteDetail="scope.row.id">行程详情</span>
                          </el-dropdown-item>
                          <el-dropdown-item v-goRouteReplay="{
                            id: scope.row.routeId,
                            orderId: scope.row.id
                          }">行程回放</el-dropdown-item>
                          <el-dropdown-item command="12">获取乘客定位</el-dropdown-item>
                          <el-dropdown-item command="11">开罚单</el-dropdown-item>
                          <el-dropdown-item command="8">显示下单地址</el-dropdown-item>
                          <el-dropdown-item command="4">发送短信</el-dropdown-item>
                          <el-dropdown-item command="9">交易明细</el-dropdown-item>
                          <el-dropdown-item command="5">操作日志</el-dropdown-item>
                          <el-dropdown-item>
                            <attachment-adder attachmentType="ORDER" :bizId="scope.row.id">
                              添加业务附件
                            </attachment-adder>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column label="电量信息" width="100px">
            <template slot-scope="scope">
              <span
                v-if="scope.row.realTimeChargeInfo"
                class="battery-info"
                :class="getBatteryClass(scope.row.realTimeChargeInfo)"
                :title="getBatteryTitle(scope.row.realTimeChargeInfo)"
              >
                <span v-if="scope.row.realTimeChargeInfo.chargeStatus === 1">充电中</span>
                <span v-else>未充电</span>
                <span> {{ scope.row.realTimeChargeInfo.totalSoc }}% </span>
              </span>
            </template>
          </el-table-column> -->

          <el-table-column label="司机编号" width="140px">
            <template slot-scope="scope">
              <span @click="showDriverLocation(scope.row.route.driverId)" class="route-info pointer"
                :class="{ blue: scope.row.bigCar }"><span> {{ scope.row.route.driverNo }}</span>

                <span v-if="scope.row.realTimeChargeInfo" class="battery-info"
                  :class="getBatteryClass(scope.row.realTimeChargeInfo)"
                  :title="getBatteryTitle(scope.row.realTimeChargeInfo)">
                  <span v-if="scope.row.realTimeChargeInfo.chargeStatus === 1">充电中</span>
                  <span v-else>未充电</span>
                  <span> {{ scope.row.realTimeChargeInfo.totalSoc }}% </span>
                </span>
              </span>
            </template>
          </el-table-column>

          <el-table-column label="剩余座位数">
            <template slot-scope="scope">
              <div class="route-info pointer" @click="toggleRow(scope.row)">
                <div class="info">
                  剩余座位数:
                  <span class="red">{{ scope.row.route.number - scope.row.route.used }}</span>
                  <span @click.stop="go2QcPage(scope.row.route)">{{ scope.row.route.date }} / {{
                    scope.row.route.showTime }}</span>
                  <span class="red" v-if="scope.row.route.number !== 3">{{ scope.row.route.number }}座车</span>

                  <span v-if="scope.row.routeSequence" :class="{ red: !scope.row.routeSequence.isConfirmed }"
                    @click.stop="showRoutePlan(scope.row.route)">
                    <i class="el-icon-share"></i>
                    {{
                      scope.row.routeSequence.isConfirmed ? "行程规划" : "行程规划（未确认）"
                    }}</span>
                  <span v-else class="red">行程规划计算中,请3秒后刷新</span>

                  <span class="qc process1" @click.stop="go2MonitorPage(scope.row.route)">
                    监控
                  </span>

                  <span class="on-highway" v-if="scope.row.gettingOffHighway" style="color: #4caf50">
                    下高速
                  </span>
                  <span class="on-highway" @click.stop="changeHighwayStatus(scope.row, 2)"
                    v-else-if="scope.row.gettingOntoHighway">
                    上高速
                  </span>
                  <span class="on-highway" style="color: #999" @click.stop="changeHighwayStatus(scope.row, 1)" v-else>
                    未上高速
                  </span>

                  <span v-if="!scope.row.flowPlan" :class="scope.row.flowPlan ? 'green' : 'red'">{{
                    scope.row.flowPlan ? "遵循接送规划" : "不遵循接送规划"
                  }}</span>

                  <span v-if="scope.row.baggageWarningLevel > 2"
                    :class="scope.row.baggageWarningLevel === 3 ? 'warn' : 'red'">行李预警</span>

                  <span v-if="scope.row.qcTask" class="qc" @click.stop="go2QcPage(scope.row.route)"
                    :class="`process${scope.row.qcTask.process}`">
                    <span v-if="scope.row.qcTask.process === 0">待质检</span>
                    <span v-if="scope.row.qcTask.process === 1">质检中</span>
                    <span v-if="scope.row.qcTask.process === 2">质检通过</span>
                    <span v-if="scope.row.qcTask.process === 3">质检不合格</span>
                  </span>

                  <span v-if="scope.row.hasShunt" @click.stop="showShuntMap(scope.row.route, scope.row.orderList)">
                    <span :class="{ red: scope.row.hasShunt, grey: scope.row.shuntAllFinished }"><i
                        class="el-icon-s-flag"></i>分流</span>

                    <span v-if="scope.row.shuntTipInfo" :class="{ red: scope.row.shuntTipInfo.timeBeforeShunt < 15 }">
                      <count-down :key="scope.row.shuntTipInfo.routeId" :targetTime="scope.row.shuntTipInfo.shuntTime"
                        overTimeText="立即分流" />
                    </span>
                  </span>

                  <img src="../../../assets/image/notonway.png" v-if="!scope.row.route.controlArea"
                    style="width: 20px; height: 20px; position: relative; top: 3px" />

                  <el-popover placement="right" width="600" trigger="hover" v-if="scope.row.punishBillList.length">
                    <el-table :data="scope.row.punishBillList" size="small" :show-header="false">
                      <el-table-column property="violateClassify2" label="违规项">
                        <template slot-scope="scope">
                          {{ scope.row.violateClassify2 | enumTransfer(violateClassify2Opts) }}
                        </template>
                      </el-table-column>
                      <el-table-column property="orderDesc" label="订单"></el-table-column>
                      <el-table-column property="violateSrc" label="罚单来源">
                        <template slot-scope="scope">
                          {{ scope.row.violateSrc | enumTransfer(violateSrcOpts) }}
                        </template>
                      </el-table-column>
                      <el-table-column property="punishResult" label="处罚结果"></el-table-column>
                      <el-table-column property="id" label="详情">
                        <template slot-scope="scope2">
                          <el-link type="primary" @click="showPunishBill(scope2.row)">详情</el-link>

                          <el-link type="primary" style="margin-left: 6px" :disabled="scope2.row.appealed"
                            @click="cancelPunish(scope.$index, scope2.$index)">{{ scope2.row.appealed ? "已免责" : "免责"
                            }}</el-link>
                        </template>
                      </el-table-column>
                    </el-table>
                    <span style="color: #03a9f4" slot="reference">
                      <i class="el-icon-scissors"></i> 罚单
                    </span>
                  </el-popover>
                </div>

                <div class="right-op-box">

                  <el-button type="text" @click.stop="showShuntMap(scope.row.route, scope.row.orderList)">
                    安排分流</el-button>

                  <el-button type="text" @click.stop="pre2Matched(scope.row.route)" v-if="scope.row.route.needToMatch">
                    预派转正式</el-button>

                  <el-dropdown @click.stop @command="
                    (command) => handleRouteCommand(command, scope.row.route, scope.row.orderList)
                  ">
                    <span>
                      <span>行程操作</span>
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="3" v-if="scope.row.route.status !== 'FINISH'">行程到达</el-dropdown-item>
                      <el-dropdown-item command="4" v-if="!scope.row.orderList.length">取消空行程</el-dropdown-item>
                      <el-dropdown-item command="10"
                        v-if="scope.row.route.status === 'PRE_DISPATCH'">撤回行程</el-dropdown-item>
                      <el-dropdown-item command="13"
                        v-if="scope.row.route.status === 'PRE_DISPATCH'">改派司机</el-dropdown-item>
                      <el-dropdown-item command="5" v-if="scope.row.route.status === 'PRE_DISPATCH'">
                        {{ scope.row.route.display2Driver ? "不展示给司机" : "展示给司机" }}
                      </el-dropdown-item>
                      <el-dropdown-item command="6" v-if="scope.row.route.status !== 'FINISH'">重新计算规划</el-dropdown-item>
                      <el-dropdown-item command="7" v-if="scope.row.route.status !== 'FINISH'">
                        顺路控制</el-dropdown-item>
                      <el-dropdown-item command="8">开罚单</el-dropdown-item>
                      <el-dropdown-item command="9" v-if="scope.row.route.status !== 'FINISH'">提醒司机联系</el-dropdown-item>
                      <el-dropdown-item command="11" v-if="scope.row.route.status !== 'FINISH'">修改座位数</el-dropdown-item>
                      <el-dropdown-item command="12" v-if="isManager">导出行程数据</el-dropdown-item>
                      <!-- <el-dropdown-item command="14">行程备注</el-dropdown-item> -->
                      <el-dropdown-item command="16">行程问题</el-dropdown-item>
                      <el-dropdown-item command="17">行程日志</el-dropdown-item>
                      <el-dropdown-item command="15">语音播报</el-dropdown-item>
                      <el-dropdown-item>
                        <attachment-adder attachmentType="ROUTE" :bizId="scope.row.route.id">
                          添加业务附件
                        </attachment-adder>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page">
        <el-pagination @current-change="handleCurrentChange" background :current-page="currentPage"
          :page-size="pageSize" layout="slot, prev, pager, next, jumper" :total="total">
          <span class="pagination-sum">共{{ list.length }}个行程， {{ totalPerson }}人 </span>
        </el-pagination>
      </div>
    </div>

    <el-dialog :visible.sync="onwayVisible" width="400px" max-height="400" :close-on-click-modal="false">
      <el-radio-group v-model="selectedRoute.controlArea">
        <el-radio :label="0">不控制顺路</el-radio>
        <el-radio :label="1">宽松控顺路</el-radio>
        <el-radio :label="2">严格控顺路</el-radio>
      </el-radio-group>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="changeAreaControl">确定</el-button>
        <el-button :size="size" @click="onwayVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="routeSeatsVisible" width="400px" max-height="400" :close-on-click-modal="false">
      <el-input-number style="width: 180px" size="small" v-model="selectedRoute.number"></el-input-number>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="changeRouteSeats">确定</el-button>
        <el-button :size="size" @click="routeSeatsVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <order-cancel ref="cancelModal" :onCancel="handleCurrentChange" />
    <tel-order-modify-modal ref="modifyModal" :simpleMode="true" />

    <el-dialog :visible.sync="routeProblemVisible" title="录入行程问题" width="560px" :close-on-click-modal="false">
      <el-form :model="routeProblemForm" :rules="routeProblemRules" ref="routeProblemForm" size="small"
        label-width="70px">
        <el-form-item label="问题" prop="problem">
          <el-input v-model="routeProblemForm.problem" type="textarea" :rows="3" placeholder="请输入问题" />
        </el-form-item>
        <el-form-item label="建议">
          <el-input v-model="routeProblemForm.suggestion" type="textarea" :rows="3" placeholder="请输入建议" />
        </el-form-item>
        <el-form-item label="关联方">
          <el-select v-model="routeProblemForm.causer" placeholder="请选择关联方">
            <el-option v-for="item in routeProblemCauserOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :size="size" @click="routeProblemVisible = false">取消</el-button>
        <el-button :size="size" type="primary" :loading="routeProblemLoading" @click="saveRouteProblem">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getActiveRouteList,
  updatePreDispatch2Match,
  preDispatchShow2Driver,
  cancelEmptyRoute,
  createSysRoutePlan,
  changeRouteAreaControl,
  abnormalFinishOrder,
  getDriverInfo,
  tipDriver,
  dealPunishAppeal,
  rollbackRoute,
  modifyRouteSeats,
  updateRouteRemark,
  sendLocationRequest,
  ttsBroadcast,
  saveOrUpdateRouteProblem,
  updateRouteHighwayStatus
} from "@/api";
import TelOrderModifyModal from "@/components/TelOrder/TelOrderModifyModal";
import TelCell from "@/components/TelCell";
import { mapState } from "vuex";
import {
  SHOW_DRIVER_CHARGE_INFO_MODAL,
  SHOW_ROUTE_MAP,
  SHOW_SHUNT_MAP,
  SHOW_BOOK_ADDRESS_MAP,
  SHOW_REALTIME_LOCATION,
  SHOW_ROUTE_PLAN,
  SHOW_CHANGE_ORDER_MODAL,
  SHOW_PUNISH_DIAG,
} from "@/core/const/global-event";
import _ from "lodash";
import Router from "@/route";
import { openDriverMonitor } from "@/util/monitorDevice";

export default {
  filters: {
    baggagesRemarkFilter(val) {
      if (val) {
        return val.substr(1);
      }
      return val;
    }
  },
  components: {
    TelOrderModifyModal,
    TelCell
  },
  props: {
    recallOrder: Function,
    auditBaggage: Function,
    sendSms: Function,
    showTransactionDetail: Function,
    changeRouteDriver: Function
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      isManager: (state) => state.isManager,
      orderStatusOpts: (state) => state.enumMap["ORDER_STATUS"],
      routeDetailOpts: (state) => state.enumMap["ROUTE_DETAIL_STATUS"],
      payStatusOpts: (state) => state.enumMap["PAY_STATUS"],
      violateClassify2Opts: (state) => state.enumMap["DRIVER_VIOLATE_OPT_TYPE"],
      violateSrcOpts: (state) => state.enumMap["EVA_SOURCE_CHANNEL"],
      shuntTipInfos: (state) => state.shuntTipInfos
    })
  },

  watch: {
    shuntTipInfos: {
      handler(newVal) {
        this.handleShuntTipInfos(newVal);
      }
    }
  },

  data() {
    return {
      ticketDiagVisible: false,
      list: [],
      tableKey: 0,
      pageSize: 100,
      currentPage: 1,
      total: 0,
      currentOrderId: null,
      ticketList: [],
      loading: false,
      param: {},
      totalPerson: 0,
      selectedRoute: {},
      onwayVisible: false,
      routeSeatsVisible: false,
      routeProblemVisible: false,
      routeProblemForm: {},
      routeProblemLoading: false,
      routeProblemCauserOptions: [
        { label: "司机", value: "DRIVER" },
        { label: "系统", value: "SYSTEM" },
        { label: "客服", value: "SERVICE" },
        { label: "乘客", value: "PASSENGER" },
        { label: "其他", value: "OTHER" }
      ],
      routeProblemRules: {
        problem: [{ required: true, message: "请填写问题", trigger: "blur" }]
      }
    };
  },
  methods: {
    showOnwayDetect(row) {
      this.$emit("show-onway", row);
    },

    query(page = 1, param = this.param || {}) {
      this.param = param;
      param.orderStatus = "MATCHED";
      const query = {
        page: {
          current: page,
          size: this.pageSize
        },
        param
      };
      getActiveRouteList(query).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;

        let totalPerson = 0;
        records.forEach((item) => {
          totalPerson += item.route.used;
          // 是否查看分流信息
          const isUnreadShunt =
            (item.route.isStartShunt && !item.route.isReadStartShunt) ||
            (item.route.isEndShunt && !item.route.isReadEndShunt);
          item.route.unreadShunt = isUnreadShunt;

          for (let index = 0; index < item.orderList.length; index++) {
            const order = item.orderList[index];
            if (order.orderStatus === "PRE_DISPATCH") {
              item.route.needToMatch = true;
              break;
            }
          }
        });
        this.totalPerson = totalPerson;

        // 换查询条件后表格会复用上一轮的行和斑马纹，展开区背景会串色。换 key 整表重建。
        this.tableKey += 1;
      });
    },

    toggleRow(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    showDriverLocation(driverId) {
      this.$bus.$emit(SHOW_DRIVER_CHARGE_INFO_MODAL, driverId);
    },
    /**
     * 获取电池样式类
     * @param {Object} chargeInfo - 实时充电信息
     * @returns {String} 样式类名
     */
    getBatteryClass(chargeInfo) {
      if (!chargeInfo || chargeInfo.totalSoc === null || chargeInfo.totalSoc === undefined) {
        return "battery-unknown";
      }
      const soc = chargeInfo.totalSoc;
      const isCharging = chargeInfo.chargeStatus === 1;

      if (isCharging) {
        return "battery-charging";
      } else if (soc < 20) {
        return "battery-low";
      } else if (soc < 50) {
        return "battery-medium";
      } else {
        return "battery-high";
      }
    },
    /**
     * 获取电池提示信息
     * @param {Object} chargeInfo - 实时充电信息
     * @returns {String} 提示文本
     */
    getBatteryTitle(chargeInfo) {
      if (!chargeInfo) {
        return "未知";
      }
      const soc =
        chargeInfo.totalSoc !== null && chargeInfo.totalSoc !== undefined
          ? `${chargeInfo.totalSoc}%`
          : "未知";
      const isCharging = chargeInfo.chargeStatus === 1;
      const rangeMileage =
        chargeInfo.rangeMileage !== null && chargeInfo.rangeMileage !== undefined
          ? `${chargeInfo.rangeMileage}km`
          : "未知";

      let status = isCharging ? "充电中" : "未充电";
      return `电量: ${soc} | 状态: ${status} | 续航: ${rangeMileage}`;
    },
    showRealTimePosition(order) {
      this.$bus.$emit(SHOW_REALTIME_LOCATION, order);
    },

    handleCommand(command, order, route) {
      command = parseInt(command);
      switch (command) {
        case 1:
          this.openCancelModal(order);
          break;
        case 2:
          this.openUpdateModal(order);
          break;
        case 3:
          this.recallOrder(order);
          break;
        case 4:
          this.sendSms(order.id);
          break;
        case 5:
          this.$orderLog().show(order.id);
          break;
        case 8:
          this.showBookAddress(order);
          break;
        case 9:
          this.showTransactionDetail(order);
          break;
        case 10:
          this.abnormalFinish(order);
          break;
        case 11:
          this.createPunishBill(route, order);
          break;
        case 12:
          this.getPassengerLocation(order);
          break;
      }
    },

    handleRouteCommand(command, route) {
      this.selectedRoute = { ...route };
      command = parseInt(command);
      switch (command) {
        case 3:
          this.routeArrive(route);
          break;
        case 4:
          this.cancelRoute(route);
          break;
        case 5:
          this.preShow2Driver(route);
          break;
        case 6:
          this.calcRoutePlan(route);
          break;
        case 7:
          this.onwayVisible = true;
          break;
        case 8:
          this.createPunishBill(route);
          break;
        case 9:
          this.hurryUpDriver(route);
          break;
        case 10:
          this.rollbackRoute(route);
          break;
        case 11:
          this.routeSeatsVisible = true;
          break;
        case 12:
          this.exportRouteCheckData(route);
          break;
        case 13:
          this.changeRouteDriver(route);
          break;
        case 14:
          this.remarkRoute(route);
          break;
        case 15:
          this.ttsBroadcast(route);
          break;
        case 16:
          this.openRouteProblemDialog(route);
          break;
        case 17:
          this.$routeLog().show(route.id);
          break;
      }
    },

    remarkRoute(route) {
      this.$prompt("请输入备注", "备注", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          const param = {
            id: route.id,
            remark: value
          };
          updateRouteRemark(param).then(() => {
            this.$message.success("操作成功");
            this.query();
          });
        })
        .catch(() => { });
    },

    exportRouteCheckData(route) {
      window.open(`/admin/route/check/download/route_data?routeId=${route.id}`);
    },

    rollbackRoute(route) {
      this.$confirm("确认撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        rollbackRoute(route.id).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    hurryUpDriver(route) {
      this.$confirm("确认催促司机吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        tipDriver(route.id).then(() => {
          this.$message.success("操作成功");
        });
      });
    },

    createPunishBill(route, order) {
      this.$bus.$emit(SHOW_PUNISH_DIAG, { order, route });
    },

    showPunishBill(punishBill) {
      this.$bus.$emit(SHOW_PUNISH_DIAG, { punishBill: _.cloneDeep(punishBill), viewMode: true });
    },

    abnormalFinish(item) {
      this.$confirm("确认关单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        abnormalFinishOrder(item.id).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    changeAreaControl() {
      changeRouteAreaControl(this.selectedRoute).then(() => {
        this.onwayVisible = false;
        this.$message.success("操作成功");
        this.query();
      });
    },

    changeRouteSeats() {
      const { id, number } = this.selectedRoute;

      modifyRouteSeats(id, number).then(() => {
        this.routeSeatsVisible = false;
        this.$message.success("操作成功");
        this.query();
      });
    },

    calcRoutePlan(route) {
      const { id } = route;
      createSysRoutePlan({ routeId: id }).then(() => {
        this.$message.success("操作成功");
        this.query();
      });
    },

    showRoutePlan(route) {
      this.$bus.$emit(SHOW_ROUTE_PLAN, route, false);
    },

    cancelRoute(route) {
      this.$confirm("确认取消行程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelEmptyRoute(route.id).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    pre2Matched(route) {
      this.$confirm("确认正式指派吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const param = {
          routeId: route.id,
          pathId: route.pathId
        };
        updatePreDispatch2Match(param).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    preShow2Driver(route) {
      const val = !route.display2Driver;
      this.$confirm(val ? "确认展示给司机查看吗？" : "确认取消展示给司机查看吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const param = {
          routeId: route.id,
          isShow: val
        };
        preDispatchShow2Driver(param).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    showPassengetMap(route, orders, isStart) {
      this.$bus.$emit(SHOW_ROUTE_MAP, route, orders, isStart);
    },

    showShuntMap(route, orders) {
      this.$bus.$emit(SHOW_SHUNT_MAP, route, orders);
    },

    showBookAddress(item) {
      this.$bus.$emit(SHOW_BOOK_ADDRESS_MAP, item);
    },

    routeArrive(route) {
      this.$confirm("确认司机已到达吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.get("/admin/scheduling/end_trip", { routeId: route.id }).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    getPassengerLocation(order) {
      this.$confirm("确认申请乘客定位吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        sendLocationRequest({ driverId: order.driverId, orderId: order.id }).then(() => {
          this.$message.success("发送成功");
        });
      });
    },

    handleCurrentChange(page) {
      this.query(page);
    },

    openCancelModal(item) {
      this.$refs.cancelModal.open(item.id);
    },

    openUpdateModal(item) {
      this.$bus.$emit(SHOW_CHANGE_ORDER_MODAL, item);
    },

    openMsgModal(item) {
      this.$refs.modifyModal.open(item);
    },

    tableRowClassName({ row }) {
      // 确保 row 和 route 存在，防止报错
      if (!row || !row.route) {
        return "";
      }
      const status = row.route.status;
      if (status === "FINISH") {
        return "finish";
      } else if (status === "PRE_DISPATCH") {
        return "pre-dispatch";
      }
      return "";
    },

    aduitBag(item, viewMode) {
      this.auditBaggage(item, viewMode);
    },

    go2QcPage(item) {
      const { href } = Router.resolve({
        path: "/route/qc",
        query: { routeId: item.id }
      });
      window.open(href, "_blank");
    },

    async go2MonitorPage(item) {
      const driverResp = await getDriverInfo({ id: item.driverId });
      const message = openDriverMonitor(driverResp.data);
      if (message) {
        this.$message.warning(message);
      }
    },

    cancelPunish(routeIndex, punishIndex) {
      this.$confirm("确认免责吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const route = this.list[routeIndex];
        const item = route.punishBillList[punishIndex];
        dealPunishAppeal(item.id)
          .then((res) => {
            route.punishBillList[punishIndex].appealed = 1;
            this.$set(this.list, routeIndex, route);
            const punishAmount = res.data || 0;
            if (punishAmount > 0) {
              this.$message.success(`免责成功，已罚款金额${punishAmount}元需人工处理`);
            } else {
              this.$message.success("免责成功");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      });
    },

    async ttsBroadcast(item) {
      const driverResp = await getDriverInfo({ id: item.driverId });
      const driver = driverResp.data || {};
      if (!driver.videoDeviceId) {
        this.$message.warning(driver.newVideoDeviceId ? "智驾设备暂不支持语音播报" : "没有监控设备");
        return;
      }
      await ttsBroadcast(driver.videoDeviceId, "请注意行车安全。");
    },

    openRouteProblemDialog(route) {
      this.routeProblemForm = {
        problem: "",
        suggestion: "",
        causer: "",
        routeId: route.id,
        driverNo: route.driverNo,
        driverId: route.driverId
      };
      this.routeProblemVisible = true;
    },

    async saveRouteProblem() {
      this.$refs.routeProblemForm.validate(async (valid) => {
        if (!valid) return;
        this.routeProblemLoading = true;
        try {
          if (!this.routeProblemForm.causer) {
            this.$message.error("请选择关联方");
            this.routeProblemLoading = false;
            return;
          }
          await saveOrUpdateRouteProblem(this.routeProblemForm);
          this.$message.success("保存成功");
          this.routeProblemVisible = false;
          this.query();
        } catch (e) {
          // 错误处理
        } finally {
          this.routeProblemLoading = false;
        }
      });
    },

    handleShuntTipInfos(newVal) {
      this.list.forEach((item, index) => {
        const { route } = item;
        const shuntTipInfo = newVal.find((info) => info.routeId === route.id);
        if (shuntTipInfo) {
          this.$set(this.list[index], "shuntTipInfo", shuntTipInfo);
        }
      });
    },

    changeHighwayStatus(item, status) {
      let text;
      if (status === 1) {
        text = "确认已上高速吗？";
      } else {
        text = "确认已下高速吗？";
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        updateRouteHighwayStatus(item.route.id, status).then(() => {
          this.$message.success("操作成功");
          const index = this.list.findIndex((t) => t.route.id === item.route.id);
          if (status === 1) {
            this.$set(this.list[index], "gettingOntoHighway", true);
          } else {
            this.$set(this.list[index], "gettingOffHighway", true);
          }
        });
      });
    },



  }
};
</script>
<style lang="less" scoped>
// 颜色变量
@primary-color: #409eff;
@success-color: #67c23a;
@warning-color: #e6a23c;
@danger-color: #f56c6c;
@info-color: #909399;
@text-color: #303133;
@border-color: #dcdfe6;

// 行状态背景色
@finish-bg: blanchedalmond;
@pre-dispatch-bg: #e3fbc7;
@expanded-bg: rgba(224, 232, 251, 0.23);
@expanded-striped-bg: rgba(194, 255, 164, 0.26);

// 电池状态颜色
@battery-low: @danger-color;
@battery-medium: @warning-color;
@battery-high: @success-color;
@battery-charging: @primary-color;
@battery-unknown: @info-color;

// 质检状态颜色
@qc-process0: @primary-color;
@qc-process1: orange;
@qc-process2: #56c556;
@qc-process3: @danger-color;
@qc-process-default: #adb1ac;

// 通用样式
.together {
  font-size: 12px;
  color: @danger-color;
}

.grey {
  color: @info-color !important;
}

// 行状态样式 - 使用更精确的选择器确保样式生效
/deep/ .el-table {
  .el-table__row.finish {
    td {
      background: @finish-bg !important;
    }

    &:hover td {
      background: @finish-bg !important;
    }

    // 处理 stripe 模式
    &.el-table__row--striped td {
      background: @finish-bg !important;
    }
  }

  .el-table__row.pre-dispatch {
    td {
      background: @pre-dispatch-bg !important;
    }

    &:hover td {
      background: @pre-dispatch-bg !important;
    }

    // 处理 stripe 模式
    &.el-table__row--striped td {
      background: @pre-dispatch-bg !important;
    }
  }
}

// 展开行样式 - 优化后的版本
/deep/ .route-detail .no-hover {
  .table-expand {
    padding-left: 40px;
  }

  // 统一的展开行背景设置mixin
  .expanded-row-bg(@bg-color) {
    .el-table tr {
      background-color: @bg-color !important;

      &:hover {
        background-color: @bg-color !important;
      }
    }

    .table-expand {
      background-color: @bg-color;
    }
  }

  // 普通展开行
  .expanded+tr {
    .expanded-row-bg(@expanded-bg);
  }

  // 斑马纹展开行
  .expanded.el-table__row--striped+tr {
    .expanded-row-bg(@expanded-striped-bg);
  }

  // 重置斑马纹背景
  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #fff;
  }
}

// 路由信息样式
.route-info {
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.blue {
    color: @primary-color;
  }

  .info {
    cursor: pointer;

    >span {
      margin-right: 20px;
    }
  }
}

// 电池信息样式
.battery-info {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  i {
    font-size: 16px;
  }

  &.battery-low {
    color: @battery-low;
  }

  &.battery-medium {
    color: @battery-medium;
  }

  &.battery-high {
    color: @battery-high;
  }

  &.battery-charging {
    color: @battery-charging;

    i.el-icon-loading {
      animation: rotating 2s linear infinite;
    }
  }

  &.battery-unknown {
    color: @battery-unknown;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

// 链接和操作样式
.el-dropdown-link {
  margin-left: 10px;
  cursor: pointer;
  color: @primary-color;
  font-size: 12px;
}

.pagination-sum {
  color: @danger-color;
  margin: 0 10px;
}

.right-op-box {
  display: flex;
  align-items: center;

  .el-button--text {
    padding: 0;
    margin-right: 10px;
  }
}

.on-highway {
  color: @primary-color;
}

// 质检状态样式
.qc {
  margin-left: 10px;
  cursor: pointer;
  color: white;
  padding: 5px 16px;
  border-radius: 6px;
  font-size: 13px;
  background-color: @qc-process0; // 默认背景色

  &.process0 {
    background-color: @qc-process0;
  }

  &.process1 {
    background-color: @qc-process1;
  }

  &.process2 {
    background-color: @qc-process2;
  }

  &.process3 {
    background-color: @qc-process3;
  }

  &.process {
    background-color: @qc-process-default;
  }
}
</style>
